import React, { useState } from 'react';
import { Reveal } from '../ui/Reveal';
import { ServiceCard } from '../ui/ServiceCard';
import { SERVICES } from '../../data/services';

export const Services = () => {
  // Tracks which service is clicked
  const [selectedService, setSelectedService] = useState(null);

  // Closes the popup
  const closeModal = () => setSelectedService(null);

  return (
    <section className="sec" id="services">
      <Reveal><div className="slabel">What we offer</div></Reveal>
      <Reveal delay="1"><h2 className="stitle">Our <em>services</em></h2></Reveal>
      
      {/* ── Main Grid (Shows Compact Version) ── */}
      <div className="services-grid">
        {SERVICES.map((service, idx) => (
          <Reveal key={service.id} delay={((idx % 3) + 1).toString()}>
            <div 
              onClick={() => setSelectedService(service)} 
              style={{ cursor: 'pointer', height: '100%' }}
            >
              {/* compact={true} hides the images and tech stack here */}
              <ServiceCard service={service} compact={true} />
            </div>
          </Reveal>
        ))}
      </div>

      {/* ── The Popup Modal (Shows Full Version) ── */}
      <div 
        className={`pmodal-overlay ${selectedService ? 'open' : ''}`} 
        onClick={closeModal}
      >
        <div 
          className="pmodal" 
          onClick={(e) => e.stopPropagation()} 
          style={{ 
            padding: '0', 
            background: 'transparent', 
            border: 'none',
            maxWidth: '900px' // Allows the case study images to expand nicely
          }}
        >
          {/* Close Button */}
          <button 
            className="pmodal-close" 
            onClick={closeModal}
            style={{ 
              zIndex: 10,
              background: 'rgba(10, 9, 8, 0.8)',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              top: '-50px',
              right: '0'
            }}
          >
            ✕
          </button>
          
          {/* compact={false} shows ALL your original info, features, and images here */}
          {selectedService && (
            <ServiceCard service={selectedService} compact={false} />
          )}
        </div>
      </div>
    </section>
  );
};